import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserGuideModalComponent } from '../user-guide-modal/user-guide-modal.component';
import { LayoutService } from '../../layout.service';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { TreeNode } from '../../../pages/tree/tree-controller/tree-async/models/TreeNode';

@Component({
  selector: 'app-user-guide',
  imports: [MatIcon, MatIconButton],
  templateUrl: './user-guide-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-guide-button.component.scss',
})
export class UserGuideButtonComponent {
  private dialog = inject(MatDialog);
  private layoutService = inject(LayoutService);

  private lastItem: TreeNode;

  constructor() {
    toObservable(this.layoutService.selectedItemSignal)
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (item) => {
          // console.log('selectedItem:', item);
          this.lastItem = item;
        },
      });
  }

  openModal() {
    // console.log('Data ', this.lastItem?.item_type_code);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      type: this.lastItem?.item_type_code,
    };
    this.dialog.open(UserGuideModalComponent, dialogConfig);
  }
}
